import React from 'react';
import { AddSquareIcon, ArrowDownIcon, CloseIcon, DownloadIcon, FilterIcon, SearchIcon } from '../../../assets/icons';
import { SearchInput } from '../../common/SearchInput';
import { Filter } from '../../../@types/inventory';
import { DropdownComponent } from '../../core/Forms';
import { FILTER_LIST } from '../../../constants';
import { DropDown, GroupButton } from '../../common';
import Chip from '../../common/Chip';
import InventoryFilter from '../InventoryFilter';

interface HeadProps {
  buttons: Array<{
    text: string;
    icon: any;
    onClick?: () => void;
    href?: string;
  }>;
  handleSearch?: (text: string) => void;
  handleFilter?: (filter: Filter) => void;
  filter?: Filter;
  handleSort?: (text: string) => void;
  handleSearchSelect?: (item: any) => void;
  isSearching?: boolean;
  searchResult: any[];
  searchDisplayKey: string;
  searchPlaceHolder: string;
}

const InventoryDesktopHead: React.FC<HeadProps> = (props) => {
  const [text, setText] = React.useState('');
  const [selectedValue, setSelectedValue] = React.useState(' Recent');
  const dropDownArray = FILTER_LIST;
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [isSearching, setIsSearching] = React.useState(true);

  const handleSearch = async (text: string) => {
    if (!text || text.length < 2) return;

    try {
      setIsSearching(true);
      await props.handleSearch?.(text);
    } catch (error) {
      console.error('Error occurred during search:', error);
    } finally {
      setIsSearching(false);
    }
  };

  const handleDropDownChange = (value: string) => {
    console.log(value);
    props.handleSort ? props.handleSort(value) : null;
  };

  const handleChipClose = (chipKey: keyof Filter) => {
    if (props?.filter) {
      let newFilter = { ...props?.filter };
      if (chipKey in newFilter) {
        if (typeof newFilter[chipKey] === 'string') {
          (newFilter[chipKey] as string) = '';
        }
      }
      props.handleFilter ? props.handleFilter(newFilter as Filter) : undefined;
      console.log('Filtering with filter:', props.handleFilter);
    }
  };

  const renderFilterChip = () => {
    const chips = [];
    const filterLabels = {
      stockStatus: 'stockStatus',
      variantStatus: 'variantStatus',
    };

    if (props.filter) {
      for (const key in filterLabels) {
        const filterKey = key as keyof Filter;
        if (filterKey in props.filter && props.filter[filterKey] !== null && props.filter[filterKey] !== '') {
          const label = props.filter[filterKey];
          chips.push(<Chip key={filterKey} label={label} clearAction={() => handleChipClose(filterKey)} />);
        }
      }
    }

    return chips;
  };

  return (
    <div>
      <div className="mt-4 md:flex md:justify-between md:items-center">
        <div className="hidden md:block h-[50px] lg:pl-0 md:ml-0 lg:mt-[0em]">
          <GroupButton buttons={props.buttons} />
        </div>

        <div className="flex justify-between items-center md:justify-end md:gap-4 lg:gap-36 xl:gap-56 lg:mt-0">
          {/* <div className="bg-white p-3 text-black hidden md:block lg:hidden rounded-md">
            <SearchIcon color={'#212121'} />
          </div> */}
          <div className="relative lg:block">
            <SearchInput
              placeholder="Search for Inventory"
              displayKey={props.searchDisplayKey}
              isLoading={isSearching}
              value={text}
              onSelect={props.handleSearchSelect}
              handleChangeText={handleSearch}
              clearIcon={CloseIcon}
              data={props.searchResult}
              emptyMessage={'This Item is not found'}
              dropdownStyle={{
                maxHeight: '800px',
                overflowY: 'auto',
              }}
              classNames="w-[202px] block p-4 pl-10 xl:w-[300px] lg:w-[200px] md:mt-[0em] lg:ml-[0em] !xl:ml-[0em] border border-gray-300 bg-white max-h-[48px] min-h-[48px] placeholder:text-[15.25px] h-[39.77px] rounded p-2 mt-[5px] focus:outline-none focus:shadow-outline appearance-none lg:focus:ring-0 leading-normal"
            />
            <div className="absolute inset-y-0 left-[-1px] flex items-center pl-3 pointer-events-none">
              <SearchIcon />
            </div>
          </div>
          <div>
            <div className="flex justify-between items-center">
              <DropdownComponent
                options={dropDownArray}
                value={selectedValue}
                selectedValue={selectedValue}
                setSelectedValue={setSelectedValue}
                isSubmitted={isSubmitted}
                onFilter={handleDropDownChange}
                dropdownClassName="w-[140px] md:max-w-[200px] md:mt[0 lg:mt-0  xl:w-full md:mr-[0em] lg:w-[120px] xl:w-full lg:ml-[-7em] xl:ml-[-10em] lg:mt-0 xl:w-[300px] bg-white rounded xl:rounded xl:focus:ring-0 xl:pointer-events "
                iconClassName="xl:mt-[3px] mr-[1em] mt-[0em] md:mt-[0.3em] md:mr-[1.2em] md:mt-[0.5em]"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex">{renderFilterChip()}</div>
    </div>
  );
};

export default InventoryDesktopHead;
